import { render, staticRenderFns } from "./LastAudit.vue?vue&type=template&id=2c316d70&scoped=true&"
import script from "./LastAudit.vue?vue&type=script&lang=ts&"
export * from "./LastAudit.vue?vue&type=script&lang=ts&"
import style0 from "./LastAudit.vue?vue&type=style&index=0&id=2c316d70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c316d70",
  null
  
)

export default component.exports